<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Mass Outages
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                Click here to sync all down monitors with better uptime:
                <button v-if="user.userType === 'admin' || user.userType === 'super-admin'" :disabled="syncMassOutagesLoader" @click="syncMassOutages()" class="btn btn-primary pull-right btn-sm mr-3" >
                  <span>Monitors SYNC (Mass Outages)</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  name: "MassOutages",
  data () {
    return {
      syncMassOutagesLoader: false,
    }
  },
  methods: {
    syncMassOutages(){
      this.syncMassOutagesLoader = true;
      this.$http.post('/monitor/sync-mass-outages', {grant_type: 'token'}).then(resp => {
        swal('Synchronized!', resp.data.msg, 'success');
        this.addLog({
          message: 'Successfully synchronized monitors (Mass Outages)!',
          level: "info"
        })
      }).catch(e => {
        console.error(e);
        swal('Error!', 'Something went wrong while synchronizing monitors!', 'error');
      }).finally(() => {
        this.syncMassOutagesLoader = false;
      })
    },
  }
}
</script>

<style scoped>

</style>
